import { Link } from 'react-router-dom';

interface MovieCardProps {
  slug: string;
  title: string;
  titleEn: string;
  coverImage: string;
  rating: number;
  year: number;
  category: string;
  region: string;
  tags: string[];
  isLarge?: boolean;
}

const regionLabels: Record<string, string> = {
  'japanese-movie': '日本',
  'korean-movie': '韩国',
};

export default function MovieCard({
  slug,
  title,
  titleEn,
  coverImage,
  rating,
  year,
  tags,
  region,
  isLarge = false,
}: MovieCardProps) {
  const regionLabel = regionLabels[region] || '';

  return (
    <Link
      to={`/article/${slug}`}
      className="group block cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className={`relative overflow-hidden rounded-lg ${isLarge ? 'aspect-[2/3]' : 'aspect-[2/3]'}`}>
        <img
          src={coverImage}
          alt={`${title} - ${titleEn} 日韩电影海报`}
          title={`${title} ${titleEn} - 日韩影视网高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>

        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {regionLabel && (
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-accent-500/90 text-background-950 rounded whitespace-nowrap">
              {regionLabel}
            </span>
          )}
          <span className="px-1.5 py-0.5 text-[10px] font-medium bg-background-950/70 text-foreground-200 rounded whitespace-nowrap">
            {year}
          </span>
        </div>

        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 px-1.5 py-0.5 rounded">
          <i className="ri-star-fill text-[10px] text-accent-500"></i>
          <span className="text-[10px] font-semibold text-accent-400">{rating}</span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-semibold text-foreground-50 mb-0.5 line-clamp-1 font-heading tracking-wide">
            {title}
          </h3>
          <p className="text-[11px] text-foreground-400 mb-1.5 line-clamp-1">{titleEn}</p>
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-1.5 py-0.5 text-[10px] bg-background-800/60 text-foreground-400 rounded whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg">
            <i className="ri-play-fill text-xl text-background-950 ml-0.5"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}